import { render, staticRenderFns } from "./church-select.vue?vue&type=template&id=5999186a&"
import script from "./church-select.vue?vue&type=script&lang=js&"
export * from "./church-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports